import React from 'react'
import Avatar from '@material-ui/core/Avatar'
import { useAuth } from 'lib/auth'
import * as maybe from 'lib/maybe'

export const getCoachAvatarContent = user =>
  maybe
    .of(user)
    .map(({ name, email }) => name || email)
    .map(name => name.charAt(0).toUpperCase())
    .withDefault('U')

const CoachUserAvatar = ({ className, style, ...rest }) => {
  const { user } = useAuth()

  return (
    <Avatar
      className={className}
      style={style}
      src={user?.coach?.coachProfile?.profilePhoto}
      {...rest}
    >
      {getCoachAvatarContent(user)}
    </Avatar>
  )
}

export default CoachUserAvatar
